import { render, staticRenderFns } from "./surface_title.vue?vue&type=template&id=8ec324c4&scoped=true&"
import script from "./surface_title.vue?vue&type=script&lang=ts&"
export * from "./surface_title.vue?vue&type=script&lang=ts&"
import style0 from "./surface_title.vue?vue&type=style&index=0&id=8ec324c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec324c4",
  null
  
)

export default component.exports